module.exports = __webpack_public_path__ + "img/levelup-logo.3e13d248.svg";